import React from "react";
import makeStyles from "@mui/styles/makeStyles";

import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import MenuItem from "@mui/material/MenuItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemText from "@mui/material/ListItemText";

const useStyles = makeStyles(theme => ({
  root: {
    height: 55,
    "&:hover": {
      backgroundColor: "transparent",
      "& p": {
        color: theme.palette.primary.brandPrimary,
        textTransform: "unset",
      },
    },
  },

  thumbnail: {
    width: 45,
    height: 45,
  },

  main: {
    marginLeft: theme.spacing(2),
    width: 200,
    padding: 0,
    flexGrow: 1,
  },

  title: {
    color: theme.palette.primary.brandPrimary,
    fontSize: "1.2rem",
    lineHeight: "1.25em",
  },

  subtitle: {
    fontSize: ".9rem",
  },
}));

const AddOrganizeMediaToParentMenuItem = props => {
  const { parent, onClick } = props;
  const classes = useStyles();

  return (
    <MenuItem
      classes={{ root: classes.root }}
      onClick={event => onClick(event, parent.id)}
    >
      <ListItemAvatar>
        <Avatar
          variant="rounded"
          alt={parent.name}
          src={`${parent.thumbnailUrl}&tc${Date.now()}`}
          className={classes.thumbnail}
        />
      </ListItemAvatar>
      <ListItemText>
        <div className={classes.main}>
          <Typography classes={{ root: classes.title }} noWrap>
            {parent.title || parent.name}
          </Typography>
        </div>
      </ListItemText>
    </MenuItem>
  );
};

export default AddOrganizeMediaToParentMenuItem;
